import {LOCALE_ID, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {httpInterceptorProviders} from './core/interceptadores';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {ComponentesModule} from "./core/componentes/componentes.module";
import {ToastrModule} from "ngx-toastr";
import {HttpClientModule} from "@angular/common/http";
import {NgSelectModule} from "@ng-select/ng-select";
import {DatePipe} from "@angular/common";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
import {NgxMaskDirective, provideNgxMask} from "ngx-mask";
import {MatTooltipModule} from "@angular/material/tooltip";

registerLocaleData(ptBr, 'pt-BR');

@NgModule({
  declarations: [
    AppComponent
  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        ComponentesModule,
        BrowserAnimationsModule,
        NgxMaskDirective,
        HttpClientModule,
        NgSelectModule,
      MatTooltipModule,
      ToastrModule.forRoot({
          closeButton: true,
          timeOut: 4000,
        }),
    ],
  providers: [provideNgxMask(), httpInterceptorProviders, DatePipe, {provide: LOCALE_ID, useValue: 'pt-BR'}],
  bootstrap: [AppComponent]
})
export class AppModule { }
